import type { ReactNode } from "react";
import "./cashier-presentation-v2.css";
import "./cashier-presentation-v2-uat.css";
import "./cashier-presentation-v2-vu02.css";
import "./cashier-presentation-v2-final-uat.css";
import "./future-orders-density.css";

type CashierPresentationV2Props = {
  topBar: ReactNode;
  contextBar: ReactNode;
  catalog: ReactNode;
  cart: ReactNode;
  overlays?: ReactNode;
};

/**
 * Clean Production presentation shell for the approved Leylion Cashier layout.
 *
 * This component owns geometry only. Business state, handlers, API calls,
 * permissions and E2E selectors remain in the existing Production workflow.
 *
 * Vertical contract:
 *   64px Top Bar
 *   Order Context Bar: at least 52px, grows when its content wraps
 *   remaining viewport = Workspace
 *
 * Horizontal desktop contract (RTL):
 *   Catalog 69% | Cart 31%
 *
 * The document itself never scrolls in desktop cashier mode. Only the catalog
 * product region and cart-line region may scroll internally.
 */
export function CashierPresentationV2({
  topBar,
  contextBar,
  catalog,
  cart,
  overlays
}: CashierPresentationV2Props) {
  return (
    <div className="cashier-v2" data-testid="cashier-presentation-v2">
      <div className="cashier-v2__topbar">{topBar}</div>
      <div className="cashier-v2__context">{contextBar}</div>
      <main className="cashier-v2__workspace">
        <section className="cashier-v2__catalog">{catalog}</section>
        <aside className="cashier-v2__cart">{cart}</aside>
      </main>
      {overlays}
    </div>
  );
}
